const MAXIMUM_ROOMS = 9
const ROOM_CAPACITY = 8

export class Occupancy {
  static default = () => new Occupancy([RoomOccupancy.default()])
  static fromJSON = (rooms) => new Occupancy(rooms.map(room => new RoomOccupancy(room.adults, room.children)))

  constructor(rooms = [new RoomOccupancy()]) {
    if (rooms.length > MAXIMUM_ROOMS) {
      throw Error('MAXIMUM_ROOMS')
    }
    this.rooms = rooms
    this.numberOfRooms = rooms.length
  }

  addRoom = () => new Occupancy([...this.rooms, RoomOccupancy.default()])
  removeLastRoom = () => new Occupancy([...this.rooms.filter((room, index, arr) => index < arr.length - 1)])
  addAdultIntoRoom = (roomIndexToUpdate) => new Occupancy(this.rooms.map((room, index) => index === roomIndexToUpdate ? room.addAdult() : room))
  removeAdultFromRoom = (roomIndexToUpdate) => new Occupancy(this.rooms.map((room, index) => index === roomIndexToUpdate ? room.removeAdult() : room))
  addChildIntoRoom = (roomIndexToUpdate) => new Occupancy(this.rooms.map((room, index) => index === roomIndexToUpdate ? room.addChild() : room))
  removeChildFromRoom = (roomIndexToUpdate) => new Occupancy(this.rooms.map((room, index) => index === roomIndexToUpdate ? room.removeChild() : room))
}

export class RoomOccupancy {
  static default = () => new RoomOccupancy(2, 0)

  constructor(adults, children) {
    this.adults = adults
    this.children = children
    this.minAdults = 1
    this.maxAdults = ROOM_CAPACITY - children
    this.minChildren = 0
    this.maxChildren = ROOM_CAPACITY - adults
  }

  addAdult = () => new RoomOccupancy(++this.adults, this.children, --this.maxChildren)
  removeAdult = () => new RoomOccupancy(--this.adults, this.children, ++this.maxChildren)
  addChild = () => new RoomOccupancy(this.adults, ++this.children, --this.maxAdults)
  removeChild = () => new RoomOccupancy(this.adults, --this.children, ++this.maxAdults)
}
